import { Box, Skeleton } from '@mui/material';

export const CameraSkeleton = () => (
  <Box sx={{ aspectRatio: '16/9' }}>
    <Skeleton width="100%" height="100%" variant="rectangular" />
  </Box>
);
